import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navpage from "./Components/Navbar/Navbar";
import HomePage from "./Components/Home Page/Home";
import AboutUs from "./Components/About Us/AboutUs";
import BenefitsMassage from "./Components/Benefits of Massage/BenefitsMassage";
import ContactUs from "./Components/Contact Us/ContactUs";
import AdminPanel from "./Components/Admin Panel/AdminPanel";
import ProtectedRoute from "./Components/Admin Panel/ProtectedRoute";
import MassagerPanel from "./Components/Massager Panel/Massager";
import Footer from "./Components/Footer/Footer";
import "./App.css";
import Certification from "./Components/Our Certification/Certification";

import CustomerRegistractionForm2 from "./Components/Customer Panel/Customer_Registraction_Form2";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Components/Redux/store/store";
import PageNotFound from "./Components/Page Not Found/PageNotFound";
import UnauthorizedUser from "./Components/Unauthorized User/UnauthorizedUser";
import BookNowButton from "./Components/Footer/IconSideBar/BookNow";
import AyurvedicBodyMassage from "./Components/Our Treatments 2/AyurvedicBodyMassage/AyurvedicBodyMassage";
import CuppingTherapyTreatment from "./Components/Our Treatments 2/CuppingTherapyTreatment/CuppingTherapyTreatment";
import DeepTissueMassage from "./Components/Our Treatments 2/DeepTissueMassage/DeepTissueMassage";
import SciaticaPainReliefMassage from "./Components/Our Treatments 2/SciaticaPainReliefMassage/SciaticaPainReliefMassage";
import WaxingServices from "./Components/Our Treatments 2/WaxingServices/WaxingServices";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import Fallback from "./Components/Fallback/Fallback";

function App() {
  const location = useLocation();

  // Routes where Navpage and Footer should be hidden
  const hideNavbarFooterRoutes = [
    "/admin-panel",
    "/massager-panel",
    "/admin-panel/*",
    "/massager-panel/*",
    "/admindashboard",
    "/customer-list",
    "/massager-list",
    "/add-video",
    "/report",
    "/add-massager",
    "/pending-order-report",
    "/accepted-order-report",
  ];

  // Check if the current route matches any path where Nav and Footer should be hidden
  const shouldHideNavAndFooter = hideNavbarFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  // Check if current route belongs to admin or massager panel to avoid margin
  const noMarginRoutes = [
    "/admin-panel",
    "/massager-panel",
    "/admin-panel/*",
    "/massager-panel/*",
    "/admindashboard",
    "/customer-list",
    "/massager-list",
    "/add-video",
    "/report",
    "/add-massager",
    "/pending-order-report",
    "/accepted-order-report",
  ];
  const shouldApplyMargin = !noMarginRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          {/* Conditionally render Navpage based on the route */}
          {!shouldHideNavAndFooter && <Navpage />}

          {/* Apply content margin conditionally */}

          <div className={`content ${shouldApplyMargin ? "apply-margin" : ""}`}>
            <ErrorBoundary>
              <Suspense fallback={<Fallback />}>
                <Routes>
                  {/* Default routes */}

                  <Route path="/" element={<HomePage />} />
                  {/* <Route path="/home" element={<HomePage />} /> */}
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route
                    path="/ayurvedic-body-massage"
                    element={<AyurvedicBodyMassage />}
                  />
                  <Route
                    path="/cupping-therapy-treatment"
                    element={<CuppingTherapyTreatment />}
                  />
                  <Route
                    path="/deep-tissue-massage"
                    element={<DeepTissueMassage />}
                  />
                  <Route
                    path="/sciatica-pain-relief-massage"
                    element={<SciaticaPainReliefMassage />}
                  />
                  <Route
                    path="/full-body-waxing"
                    element={<WaxingServices />}
                  />
                  <Route path="/benefits" element={<BenefitsMassage />} />
                  <Route path="/contact-us" element={<ContactUs />} />
                  <Route
                    path="/customerRegistration"
                    element={<CustomerRegistractionForm2 />}
                  />
                  <Route
                    path="/our-certification"
                    element={<Certification />}
                  />
                  <Route path="/unauthorized" element={<UnauthorizedUser />} />
                  <Route path="/*" element={<PageNotFound />} />

                  {/* Admin-specific route */}
                  <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
                    <Route path="/admin-panel/*" element={<AdminPanel />} />
                  </Route>

                  {/* Massager-specific route */}
                  <Route
                    element={<ProtectedRoute allowedRoles={["massager"]} />}
                  >
                    <Route
                      path="/massager-panel/*"
                      element={<MassagerPanel />}
                    />
                  </Route>
                </Routes>
              </Suspense>
            </ErrorBoundary>
          </div>

          {!shouldHideNavAndFooter && <BookNowButton />}

          {/* Conditionally render footer based on the route */}
          {!shouldHideNavAndFooter && <Footer />}
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
